import { useState } from "react";
import { NavLink } from "react-router-dom";
import { SearchIcon, UserIcon, MenuIcon, CloseIcon } from "../../../shared/cockpit/components/icons/Icon";
import Login from "../../../domain/platform_core/auth/components/Login";
import RegisterModal from "../../../domain/platform_core/auth/components/RegisterModal";
import "./LandingPageHeader.scss";

export default function LandingPageHeader() {
  const [isLoginOpen, setIsLoginOpen] = useState(false);
  const [isRegisterOpen, setIsRegisterOpen] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  const closeMenu = () => setIsMenuOpen(false);

  return (
    <header className="landing-page-header">
      <div className="landing-page-header__left">
        <button className="landing-page-header__hamburger" onClick={toggleMenu}>
          {isMenuOpen ? <CloseIcon /> : <MenuIcon />}
        </button>

        <nav className={`landing-page-nav ${isMenuOpen ? "landing-page-nav--open" : ""}`}>
          <NavLink
            to="/"
            onClick={closeMenu}
            className={({ isActive }) =>
              isActive
                ? "landing-page-nav__link landing-page-nav__link--active"
                : "landing-page-nav__link"
            }
          >
            Home
          </NavLink>
          <span className="landing-page-nav__divider">|</span>

          <NavLink
            to="/produkte"
            onClick={closeMenu}
            className={({ isActive }) =>
              isActive
                ? "landing-page-nav__link landing-page-nav__link--active"
                : "landing-page-nav__link"
            }
          >
            Produkte
          </NavLink>
          <span className="landing-page-nav__divider">|</span>
          <NavLink
            to="/loesungen"
            onClick={closeMenu}
            className={({ isActive }) =>
              isActive
                ? "landing-page-nav__link landing-page-nav__link--active"
                : "landing-page-nav__link"
            }
          >
            Lösungen
          </NavLink>
          <span className="landing-page-nav__divider">|</span>
          <NavLink
            to="/preise"
            onClick={closeMenu}
            className={({ isActive }) =>
              isActive
                ? "landing-page-nav__link landing-page-nav__link--active"
                : "landing-page-nav__link"
            }
          >
            Preise
          </NavLink>
        </nav>
        <button
          className="landing-page-nav__button"
          onClick={() => setIsRegisterOpen(true)}
        >
          Kostenlos registrieren
        </button>
      </div>

      <div className="landing-page-header__right">
        <SearchIcon className="landing-page-header__icon" />

        <UserIcon
          className="landing-page-header__icon"
          onClick={() => setIsLoginOpen(true)}
        />
      </div>

      <Login isOpen={isLoginOpen} onClose={() => setIsLoginOpen(false)} />
      <RegisterModal
        isOpen={isRegisterOpen}
        onClose={() => setIsRegisterOpen(false)}
      />
    </header>
  );
}
